if (window.innerWidth > 990) {
    const navItems = document.querySelectorAll('.readme-nav-list-item');

    navItems.forEach(navItem => {
    navItem.addEventListener('click', event => {
        event.preventDefault();

        const elementSelector = navItem.getAttribute('data-element-selector');
        const targetElement = document.querySelector(`.readme-item#${elementSelector}`);
        const targetPosition = targetElement.getBoundingClientRect().top;

        window.scroll({
        top: targetPosition - 90,
        behavior: 'smooth'
        });
    });
    });
}
  